var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.key,{tag:"component",attrs:{"src":_vm.src,"page":_vm.page,"view":_vm.view,"zoom":_vm.zoom,"force-enable-open-type-font-face":_vm.forceEnableOpenTypeFontFace},on:{"change-pdf-viewer":_vm.changePdfViewer}})}
var staticRenderFns = []

export { render, staticRenderFns }